import * as DepHealthRecords from './../actions/dep-health-records.actions';
import { DependantDoctor } from 'src/app/model/ngrx/health-records.model';

export type Actions = DepHealthRecords.DepHealthRecordActions;

const initialState: DependantDoctor = {
    partyType: null,
    organisationName: null,
    addressline1: null,
    addressline2: null,
    addressline3: null,
    addressline4: null,
    emailAddress: null,
    contactNumber: null,
    title: null,
    forename: null,
    middleName: null,
    surname: null,
    thirdName: null,
    postcode: '',
    depReportViewReqInd: '',
    countryCode: null,
    ukAddressIndicator: null,
};

export function depHealthReducer(state: DependantDoctor[] = [initialState], action: Actions) {
    switch (action.type) {
        case DepHealthRecords.ADD_DEP_HEALTH_RECORDS:
            return [...state, action.payload];

        // Add this case:
        case DepHealthRecords.REMOVE_DEP_HEALTH_RECORDS:
            state = [];
            return state;

        default:
            return state;
    }
}
